import React from 'react';
import { Row, Col } from 'reactstrap';
import StoreDetailsExtraInfo from './StoreDetailsExtraInfo';

function StoreDetailsRow({ id, storeId, primaryDomain, stagingDomain, domains, contactEmail, contactPhone, expand = false }) {
  // one representative domain per frontend group: the group primary, else the first
  const frontendDomains = [];
  (domains || [])
    .filter((d) => d.frontend)
    .forEach((d) => {
      const seen = frontendDomains.findIndex((f) => f.frontend === d.frontend);
      if (seen === -1) frontendDomains.push(d);
      else if (d.isPrimary || (frontendDomains[seen].isStaging && !d.isStaging && !frontendDomains[seen].isPrimary))
        frontendDomains[seen] = d;
    });

  return expand ? (
    <tr>
      <td></td>
      <td colSpan={7}>
        <Row>
          <Col xs={12} md={6}>
            <StoreDetailsExtraInfo value={id} name="ID" />
          </Col>

          <Col xs={12} md={6}>
            <StoreDetailsExtraInfo value={storeId} name="Store ID" />
          </Col>

          <Col xs={12} md={6}>
            <StoreDetailsExtraInfo isLink={true} value={primaryDomain} name="Primary Domain" />
          </Col>

          <Col xs={12} md={6}>
            <StoreDetailsExtraInfo isLink={true} value={stagingDomain} name="Staging Domain" />
          </Col>

          {frontendDomains.map((d) => (
            <Col key={d.name} xs={12} md={6}>
              <StoreDetailsExtraInfo isLink={true} value={d.name} name={d.frontend.replace('_', ' ') + ' Domain'} />
            </Col>
          ))}

          <Col xs={12} md={6}>
            <StoreDetailsExtraInfo value={contactEmail} name="Contact Email" />
          </Col>

          <Col xs={12} md={6}>
            <StoreDetailsExtraInfo value={contactPhone} name="Contact Phone" />
          </Col>
        </Row>
      </td>
    </tr>
  ) : null;
}

export default StoreDetailsRow;
